module.exports = __webpack_public_path__ + "img/biaoqian_dixiajianzhu.c83f4c91.png";